export default "__VITE_ASSET__e8e0cf0a__"